// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html , body{
  margin: 0 !important;
  padding: 0 !important;
}
 
:root{
  
  --lemon-color:#6fb104;

}
.text-lemon{

  color: var(--lemon-color) !important;
}
.bg-lemon{
 
  background-color: var(--lemon-color) !important;

}


.pagination .page-item.active .page-link {
  background-color: #a3c113;
  color: white !important;
  border-color: #a3c113;
}


.login-wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, #d3ffe8, #c6f1a7);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.login-container {
  max-width: 950px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  overflow: hidden;
}

.login-logo-bg {
  background: linear-gradient(to bottom right, #ffffff, #ffffff);
}

.login-logo {
  max-height: 300px;
  border-radius: 15px;
  transition: transform 0.3s ease;
}

.login-title {
  color: #87d007;
  font-size: 2.2rem;
  letter-spacing: 1px;
}

.login-label {
  color: #87d007;
  font-size: 15px;
}

.login-inputs {
  padding: 12px 15px;
  border-radius: 12px;
  border: 1.5px solid #d1e7cb;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  outline: none;
  transition: all 0.2s ease;
  width: 100%;
}

.login-inputs:focus {
  border: 1.5px solid #87d007;
}

.login-eye-icon {
  cursor: pointer;
  color: #87d007;
}

.login-button {
  background-color: #87d007;
  border-radius: 30px;
  padding: 12px;
  font-size: 16px;
  width: 100%;
  transition: all 0.3s ease-in-out;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.login-button:hover {
  background-color: #6fb104;
}





.gradient-text {
  color: #9f33ff;
}

.dashboard-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  background-color: #f1f1f1;
}

.flex-grow-1 {
  flex: 1 1;
  padding: 30px;
}


.sidebar {
  width: 240px;
  min-height: 100vh;
  background: white; /* Changed to white */
  color: #9F33FF; /* Changed to purple */
  padding-top: 20px;
}

.sidebar .nav-link {
  color: #9F33FF; /* Changed to purple */
  padding: 12px 20px;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.sidebar .nav-link:hover {
  background: lch(51.12% 45.38 159.33 / 0.1); /* Light purple on hover */
  color: #6fb104;
  border-left: 4px solid #9F33FF;
}
.bg-custom 
{
  background-color: #6fb104 !important;
  color: white !important;
}
.sidebar button {
  background-color: rgba(128, 0, 128, 0.1);
  border: none;
  color: #9F33FF;
  font-weight: 500;
}

.sidebar button:hover {
  background-color: rgba(128, 0, 128, 0.2);
  color: #9F33FF;
}

@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
}


/* Sidebar base styles */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100vh;
  background-color: white;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  transition: transform 0.3s ease-in-out;
  z-index: 999;
}

/* Sidebar closed on md/sm */
@media (max-width: 991px) {
  .sidebar {
    transform: translateX(-100%);
  }
  .sidebar.sidebar-open {
    transform: translateX(0);
  }
}

/* Sidebar header */
.sidebar-header {
  font-size: 1.8rem;
  font-weight: 700;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255,255,255,0.3);
  text-align: center;
  letter-spacing: 2px;
}

/* Navigation */
.sidebar-nav {
  flex-grow: 1;
  margin-top: 2rem;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-nav li {
  margin-bottom: 1.3rem;
}

.sidebar-nav a {
  display: flex;
  align-items: center;
  color: #87d007;
  font-size: 1.1rem;
  font-weight: 500;
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 8px;
  transition: background-color 0.25s ease;
}

.sidebar-nav a:hover,
.sidebar-nav a:focus {
  background: rgba(128, 0, 128, 0.1); /* Light purple */
  color: #87d007;
}

.sidebar-nav a .icon {
  margin-right: 15px;
  font-size: 1.3rem;
}

/* Logout button at bottom */
.logout-btn {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: auto;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.35);
  color: #ffdddd;
}

/* Icons inside logout */
.logout-btn .icon {
  font-size: 1.4rem;
}

/* Toggle button */
.sidebar-toggle-btn {
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 1001;
  background-color: #87d007;
  border: none;
  color: white;
  font-size: 26px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  display: none;
  transition: background 0.3s ease;
}

.sidebar-toggle-btn:hover {
  background:  #87d007;
}

/* Show toggle button on md and smaller */
@media (max-width: 991px) {
  .sidebar-toggle-btn {
    display: block;
  }
}

/* Sidebar width on very small */
@media (max-width: 575px) {
  .sidebar {
    width: 80%;
  }
}


.dashboard-wrapper {
  display: flex;
  min-height: 100vh;
}

/* Content area takes full space */
.main-content ,.container {
  flex-grow: 1;
  /* padding: 40px 30px; */
  background: #f8f9fa;
  margin-left: 260px !important;
  transition: margin-left 0.3s ease-in-out;
}

/* On smaller devices, remove margin-left when sidebar hidden */
@media (max-width: 991px) {
  .main-content {
    margin-left: 0 !important;
    margin-top: 50px;
    padding: 30px 0px !important;
  }

  /* When sidebar open, push content */
  /* .sidebar.sidebar-open + .main-content {
    margin-left: 260px;
  } */
}


/* Reset & basics */


body {
  margin: 0;
  padding: 0 !important;
  font-family: 'Poppins', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #f7f8fa;
  color: #333;
}



.dashboard-container {
  max-width: 1100px;
  margin: 30px auto 60px;
  padding: 0 20px;
}

/* Heading */
.dashboard-heading {
  font-weight: 700;
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 40px;
  color: #222;
  letter-spacing: 1.5px;
}

/* Cards grid */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
  margin-bottom: 50px;
}

/* Card styling */
.info-card {
  background: #fff;
  border-radius: 18px;
  padding: 25px 30px;
  display: flex;
  align-items: center;
  box-shadow:
    0 3px 6px rgba(0, 0, 0, 0.07),
    0 6px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: default;
}

.info-card:hover {
  transform: translateY(-8px);
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.12),
    0 12px 36px rgba(0, 0, 0, 0.10);
}

/* Icon circle */
.icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  min-height: 72px;
  border-radius: 50%;
  font-size: 36px;
  color: white;
  margin-right: 25px;
  box-shadow: 0 4px 12px rgb(0 0 0 / 0.12);
  transition: box-shadow 0.3s ease;
}

/* Icon colors */
.purple {
  background: linear-gradient(135deg, #6fb104, #6fb104);
}
.red {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
}
.orange {
  background: linear-gradient(135deg, #f39c12, #d68910);
}

/* Text in cards */
.info-content h3 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 600;
  color: #222;
  letter-spacing: 0.03em;
}

.info-content p {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #555;
}

/* Chart section */
.chart-section {
  background: #fff;
  padding: 30px 40px;
  border-radius: 20px;
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.08),
    0 12px 36px rgba(0, 0, 0, 0.06);
  max-width: 1000px;
  height: 420px;
  margin: 0 auto;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-heading {
    font-size: 2.4rem;
  }

  .chart-section {
    height: 350px;
    padding: 25px 20px;
  }
}

@media (max-width: 480px) {
  .dashboard-container {
    margin: 20px auto 40px;

  }
  .dashboard-heading {
    font-size: 2rem;
  }
  .info-card {
    padding: 20px;
  }
  .icon-circle {
    min-width: 60px;
    min-height: 60px;
    font-size: 28px;
    margin-right: 20px;
  }
  .info-content h3 {
    font-size: 20px;
  }
  .info-content p {
    font-size: 16px;
  }
  .chart-section {
    height: 280px;
    padding: 20px 15px;
  }
}


/* Override swal button color */
.swal-button {
  background-color:#87d007 !important;
  border: none !important;
  color: white !important;
}


.loader-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 10px;
  text-align: center;
}

.wavy-text {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 3rem;
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #87d007;
  letter-spacing: 4px;
}

/* Responsive font size for mobile */
@media (max-width: 600px) {
  .wavy-text {
    font-size: 1.5rem;
  }
}

.wave-letter {
  display: inline-block;
  animation-name: floatWave;
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  text-shadow: 0 0 5px #87d007;
}

@keyframes floatWave {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
    text-shadow: 0 0 15px #87d007, 0 0 30px #87d007;
  }
}

.custom-row td {
  padding: 12px 16px !important; /* inner spacing in cells */
}

.custom-row {
  border-spacing: 0 10px; /* won't work on <tr>, for gap use below workaround */
}

.card-hover:hover
{
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px !important;
}



 .spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
 0% { transform: rotate(0deg); }
 100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;;AAEvB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,+CAA+C;;AAEjD;;;AAGA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;EACzC,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;;;;;AAMA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;;AAGA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB,EAAE,qBAAqB;EACxC,cAAc,EAAE,sBAAsB;EACtC,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0CAA0C,EAAE,0BAA0B;EACtE,cAAc;EACd,8BAA8B;AAChC;AACA;;EAEE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;;AAGA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sCAAsC;EACtC,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;EAEE,kCAAkC,EAAE,iBAAiB;EACrD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE;IACE,cAAc;EAChB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA,+DAA+D;AAC/D;EACE;IACE,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA,oCAAoC;EACpC;;KAEG;AACL;;;AAGA,mBAAmB;;;AAGnB;EACE,SAAS;EACT,qBAAqB;EACrB,uEAAuE;EACvE,mBAAmB;EACnB,WAAW;AACb;;;;AAIA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB;;kCAEgC;EAChC,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B;;mCAEiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB;;mCAEiC;EACjC,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;;EAExB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;;AAGA,+BAA+B;AAC/B;EACE,mCAAmC;EACnC,uBAAuB;EACvB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,4DAA4D;EAC5D,cAAc;EACd,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;IAC5B,+CAA+C;EACjD;AACF;;AAEA;EACE,6BAA6B,EAAE,2BAA2B;AAC5D;;AAEA;EACE,sBAAsB,EAAE,qDAAqD;AAC/E;;AAEA;;EAEE,kMAAkM;AACpM;;;;CAIC;EACC,kCAAkC;AACpC;AACA;CACC,KAAK,uBAAuB,EAAE;CAC9B,OAAO,yBAAyB,EAAE;AACnC","sourcesContent":["\nhtml , body{\n  margin: 0 !important;\n  padding: 0 !important;\n}\n \n:root{\n  \n  --lemon-color:#6fb104;\n\n}\n.text-lemon{\n\n  color: var(--lemon-color) !important;\n}\n.bg-lemon{\n \n  background-color: var(--lemon-color) !important;\n\n}\n\n\n.pagination .page-item.active .page-link {\n  background-color: #a3c113;\n  color: white !important;\n  border-color: #a3c113;\n}\n\n\n.login-wrapper {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(to right, #d3ffe8, #c6f1a7);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.login-container {\n  max-width: 950px;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 30px;\n  overflow: hidden;\n}\n\n.login-logo-bg {\n  background: linear-gradient(to bottom right, #ffffff, #ffffff);\n}\n\n.login-logo {\n  max-height: 300px;\n  border-radius: 15px;\n  transition: transform 0.3s ease;\n}\n\n.login-title {\n  color: #87d007;\n  font-size: 2.2rem;\n  letter-spacing: 1px;\n}\n\n.login-label {\n  color: #87d007;\n  font-size: 15px;\n}\n\n.login-inputs {\n  padding: 12px 15px;\n  border-radius: 12px;\n  border: 1.5px solid #d1e7cb;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  outline: none;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.login-inputs:focus {\n  border: 1.5px solid #87d007;\n}\n\n.login-eye-icon {\n  cursor: pointer;\n  color: #87d007;\n}\n\n.login-button {\n  background-color: #87d007;\n  border-radius: 30px;\n  padding: 12px;\n  font-size: 16px;\n  width: 100%;\n  transition: all 0.3s ease-in-out;\n  border: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.login-button:hover {\n  background-color: #6fb104;\n}\n\n\n\n\n\n.gradient-text {\n  color: #9f33ff;\n}\n\n.dashboard-wrapper {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: row;\n  background-color: #f1f1f1;\n}\n\n.flex-grow-1 {\n  flex: 1;\n  padding: 30px;\n}\n\n\n.sidebar {\n  width: 240px;\n  min-height: 100vh;\n  background: white; /* Changed to white */\n  color: #9F33FF; /* Changed to purple */\n  padding-top: 20px;\n}\n\n.sidebar .nav-link {\n  color: #9F33FF; /* Changed to purple */\n  padding: 12px 20px;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.sidebar .nav-link:hover {\n  background: lch(51.12% 45.38 159.33 / 0.1); /* Light purple on hover */\n  color: #6fb104;\n  border-left: 4px solid #9F33FF;\n}\n.bg-custom \n{\n  background-color: #6fb104 !important;\n  color: white !important;\n}\n.sidebar button {\n  background-color: rgba(128, 0, 128, 0.1);\n  border: none;\n  color: #9F33FF;\n  font-weight: 500;\n}\n\n.sidebar button:hover {\n  background-color: rgba(128, 0, 128, 0.2);\n  color: #9F33FF;\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: 100%;\n    height: auto;\n    position: relative;\n  }\n}\n\n\n/* Sidebar base styles */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 260px;\n  height: 100vh;\n  background-color: white;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  transition: transform 0.3s ease-in-out;\n  z-index: 999;\n}\n\n/* Sidebar closed on md/sm */\n@media (max-width: 991px) {\n  .sidebar {\n    transform: translateX(-100%);\n  }\n  .sidebar.sidebar-open {\n    transform: translateX(0);\n  }\n}\n\n/* Sidebar header */\n.sidebar-header {\n  font-size: 1.8rem;\n  font-weight: 700;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(255,255,255,0.3);\n  text-align: center;\n  letter-spacing: 2px;\n}\n\n/* Navigation */\n.sidebar-nav {\n  flex-grow: 1;\n  margin-top: 2rem;\n}\n\n.sidebar-nav ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-nav li {\n  margin-bottom: 1.3rem;\n}\n\n.sidebar-nav a {\n  display: flex;\n  align-items: center;\n  color: #87d007;\n  font-size: 1.1rem;\n  font-weight: 500;\n  text-decoration: none;\n  padding: 10px 12px;\n  border-radius: 8px;\n  transition: background-color 0.25s ease;\n}\n\n.sidebar-nav a:hover,\n.sidebar-nav a:focus {\n  background: rgba(128, 0, 128, 0.1); /* Light purple */\n  color: #87d007;\n}\n\n.sidebar-nav a .icon {\n  margin-right: 15px;\n  font-size: 1.3rem;\n}\n\n/* Logout button at bottom */\n.logout-btn {\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: white;\n  font-weight: 600;\n  font-size: 1.1rem;\n  border-radius: 10px;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: auto;\n}\n\n.logout-btn:hover {\n  background: rgba(255, 255, 255, 0.35);\n  color: #ffdddd;\n}\n\n/* Icons inside logout */\n.logout-btn .icon {\n  font-size: 1.4rem;\n}\n\n/* Toggle button */\n.sidebar-toggle-btn {\n  position: fixed;\n  top: 15px;\n  left: 15px;\n  z-index: 1001;\n  background-color: #87d007;\n  border: none;\n  color: white;\n  font-size: 26px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.3);\n  display: none;\n  transition: background 0.3s ease;\n}\n\n.sidebar-toggle-btn:hover {\n  background:  #87d007;\n}\n\n/* Show toggle button on md and smaller */\n@media (max-width: 991px) {\n  .sidebar-toggle-btn {\n    display: block;\n  }\n}\n\n/* Sidebar width on very small */\n@media (max-width: 575px) {\n  .sidebar {\n    width: 80%;\n  }\n}\n\n\n.dashboard-wrapper {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* Content area takes full space */\n.main-content ,.container {\n  flex-grow: 1;\n  /* padding: 40px 30px; */\n  background: #f8f9fa;\n  margin-left: 260px !important;\n  transition: margin-left 0.3s ease-in-out;\n}\n\n/* On smaller devices, remove margin-left when sidebar hidden */\n@media (max-width: 991px) {\n  .main-content {\n    margin-left: 0 !important;\n    margin-top: 50px;\n    padding: 30px 0px !important;\n  }\n\n  /* When sidebar open, push content */\n  /* .sidebar.sidebar-open + .main-content {\n    margin-left: 260px;\n  } */\n}\n\n\n/* Reset & basics */\n\n\nbody {\n  margin: 0;\n  padding: 0 !important;\n  font-family: 'Poppins', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  background: #f7f8fa;\n  color: #333;\n}\n\n\n\n.dashboard-container {\n  max-width: 1100px;\n  margin: 30px auto 60px;\n  padding: 0 20px;\n}\n\n/* Heading */\n.dashboard-heading {\n  font-weight: 700;\n  font-size: 2.8rem;\n  text-align: center;\n  margin-bottom: 40px;\n  color: #222;\n  letter-spacing: 1.5px;\n}\n\n/* Cards grid */\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 30px;\n  margin-bottom: 50px;\n}\n\n/* Card styling */\n.info-card {\n  background: #fff;\n  border-radius: 18px;\n  padding: 25px 30px;\n  display: flex;\n  align-items: center;\n  box-shadow:\n    0 3px 6px rgba(0, 0, 0, 0.07),\n    0 6px 12px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  cursor: default;\n}\n\n.info-card:hover {\n  transform: translateY(-8px);\n  box-shadow:\n    0 8px 20px rgba(0, 0, 0, 0.12),\n    0 12px 36px rgba(0, 0, 0, 0.10);\n}\n\n/* Icon circle */\n.icon-circle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 72px;\n  min-height: 72px;\n  border-radius: 50%;\n  font-size: 36px;\n  color: white;\n  margin-right: 25px;\n  box-shadow: 0 4px 12px rgb(0 0 0 / 0.12);\n  transition: box-shadow 0.3s ease;\n}\n\n/* Icon colors */\n.purple {\n  background: linear-gradient(135deg, #6fb104, #6fb104);\n}\n.red {\n  background: linear-gradient(135deg, #e74c3c, #c0392b);\n}\n.orange {\n  background: linear-gradient(135deg, #f39c12, #d68910);\n}\n\n/* Text in cards */\n.info-content h3 {\n  margin: 0 0 6px;\n  font-size: 22px;\n  font-weight: 600;\n  color: #222;\n  letter-spacing: 0.03em;\n}\n\n.info-content p {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #555;\n}\n\n/* Chart section */\n.chart-section {\n  background: #fff;\n  padding: 30px 40px;\n  border-radius: 20px;\n  box-shadow:\n    0 8px 20px rgba(0, 0, 0, 0.08),\n    0 12px 36px rgba(0, 0, 0, 0.06);\n  max-width: 1000px;\n  height: 420px;\n  margin: 0 auto;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .dashboard-heading {\n    font-size: 2.4rem;\n  }\n\n  .chart-section {\n    height: 350px;\n    padding: 25px 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-container {\n    margin: 20px auto 40px;\n\n  }\n  .dashboard-heading {\n    font-size: 2rem;\n  }\n  .info-card {\n    padding: 20px;\n  }\n  .icon-circle {\n    min-width: 60px;\n    min-height: 60px;\n    font-size: 28px;\n    margin-right: 20px;\n  }\n  .info-content h3 {\n    font-size: 20px;\n  }\n  .info-content p {\n    font-size: 16px;\n  }\n  .chart-section {\n    height: 280px;\n    padding: 20px 15px;\n  }\n}\n\n\n/* Override swal button color */\n.swal-button {\n  background-color:#87d007 !important;\n  border: none !important;\n  color: white !important;\n}\n\n\n.loader-container {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  padding: 10px;\n  text-align: center;\n}\n\n.wavy-text {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  font-size: 3rem;\n  font-weight: bold;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #87d007;\n  letter-spacing: 4px;\n}\n\n/* Responsive font size for mobile */\n@media (max-width: 600px) {\n  .wavy-text {\n    font-size: 1.5rem;\n  }\n}\n\n.wave-letter {\n  display: inline-block;\n  animation-name: floatWave;\n  animation-duration: 2.5s;\n  animation-iteration-count: infinite;\n  animation-timing-function: ease-in-out;\n  text-shadow: 0 0 5px #87d007;\n}\n\n@keyframes floatWave {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-15px);\n    text-shadow: 0 0 15px #87d007, 0 0 30px #87d007;\n  }\n}\n\n.custom-row td {\n  padding: 12px 16px !important; /* inner spacing in cells */\n}\n\n.custom-row {\n  border-spacing: 0 10px; /* won't work on <tr>, for gap use below workaround */\n}\n\n.card-hover:hover\n{\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px !important;\n}\n\n\n\n .spin {\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n 0% { transform: rotate(0deg); }\n 100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
